import PropTypes from 'prop-types'

import styled from 'styled-components'
import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'
import DefaultAvatarUrl from 'assets/img/avatar.svg'

const StyledTextWithImg = styled.div`
  display: flex;
  align-items: center;
  height: 16px;
`

const StyledImage = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 4px;
  background-size: 100%;
  border-radius: 50%;
`

const SidebarUserInfo = ({ name, avatarUrl, className }) => {
  const userIcon = avatarUrl || DefaultAvatarUrl
  return (
    <StyledTextWithImg>
      {name && <StyledImage src={userIcon} />}
      <SidebarText
        className={className}
        text={name}
      />
    </StyledTextWithImg>
  )
}

SidebarUserInfo.propTypes = {
  name: PropTypes.string,
  avatarUrl: PropTypes.string,
}

export default SidebarUserInfo
